export default {
  path: 'common',
  name: 'Common',
  childRoutes: [
  ],
};



// WEBPACK FOOTER //
// ./src/features/common/route.js